import { render } from "./App.vue?vue&type=template&id=59da5e0a&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=59da5e0a&lang=css"

import exportComponent from "/Users/zhifangxu/Documents/workspace.nosync/9teacher/code/3staudent_cli/3student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__